import { commonOptions } from '@/config/options'
import { PromotionType, ScopeType } from '@/config/enums'
import type { PageContext } from '@zto/zpage'
import dayjs from 'dayjs'

// 新增、编辑推广单
export const addEditDialog = (type: string) => {
  const isAdd = type === 'add' // 新增

  return {
    dialog: ({ app }: PageContext) => {
      return {
        width: 500,
        labelWidth: 100,
        itemSpan: 24,
        title: isAdd ? '新增配置' : '编辑配置',

        onShow: async ({ app, data }: PageContext) => {

          let mktStaySeconds = undefined
          if(!isAdd){
            mktStaySeconds = data?.mktStaySeconds || 0
          }

          return {
            payload: {
              ...(data || {}),
              mktStaySeconds
            }
          }
        },

        beforeSubmit: async ({ app, data }: PageContext, model: any, options: any) => {
          return true
        },

        onSubmit: async (payload: any, actionCfg: any, model: any, dialogExposed: any) => {
          console.info('🚀 ~ file:_dialog method:onSubmit line:1320 ----- reset', payload)
          // if (!api) {
          //   app.ui.showMessage({ type: 'warning', content: '无效操作' })
          //   return
          // }
          const { shopCode, mktStaySeconds } = payload
          const api = isAdd ? '/cabinet/admin/mkt/AdminMktShopConfigCommandController/add' : '/cabinet/admin/mkt/AdminMktShopConfigCommandController/edit'
          await app.request({
            api,
            data: {
              shopCode,
              mktStaySeconds: mktStaySeconds
            }
          })
          app.ui.showMessage({
            type: 'success',
            message: '操作成功'
          })
          // app.triggerPageSearch()
          // dialogExposed.top?.close()
        },

        formItems: [
          {
            type: 'html',
            labelWidth: 0,
            html: `<div style="background-color: #F4F4F5;padding: 0 10px; border-radius: 5px; color: #666666; font-size: 12px">
                  提示：如果添加的目的编号已存在，将直接覆盖原记录
               </div>`
          },
          {
            type: 'input',
            prop: 'shopCode',
            label: '门店编号',
            required: true,
            maxlength: 30,
            // showWordLimit: true,
            placeholder: '请输入门店编号',
            disabled: !isAdd // 新增时可以编辑，编辑时不可编辑
          },
          {
            type: 'input-number',
            label: '停留时长(秒)',
            prop: 'mktStaySeconds',
            placeholder: '请输入',
            min: 1,
            max: 60,
            precision: 0,
            dynamicAttrs: ({ data }: PageContext) => {

              return {
                hidden:false,
                required: true
              }
            }
          }
        ],

        actions:{
          close: {},
          submit: { label: '确定' }
        }
      }
    }
  }

}
